export default "__VITE_ASSET__BXTDL$86__"